import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles, Typography } from "@material-ui/core";

import { api } from "../../../../services/api";
import { CARBON_REVENUES_COLORS } from "../../constants";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import { requestDateFormat } from "../../../../services/utils";
import { UnrealizedBarChart } from "../../../../components/charts/UnrealizedBarChart";
import { NoDataCard } from "../../../../components/parts";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
}));

export const CarbonRevenueOverTime = ({ period, startDate, endDate }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);
  const title = `Carbon Revenues - Over Time (${currencySymbol})`;

  useEffect(() => {
    const getCarbonRevenueOverTime = (url) => {
      api.get(url).then((resp) => {
        const data = resp.data.map((item) => {
          const date = new Date(item.date);
          const obj = {
            ...item,
          };

          if (!("estimated" in item)) {
            obj.name = `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}`;
          }

          return obj;
        });
        setData(data);
      });
    };

    const getUrl = (period) => {
      let url = "/praas/v1/emission-impact/carbon-revenues/over-time/";
      if (period.name === "RANGE" && endDate) {
        url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
        getCarbonRevenueOverTime(url);
      } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
        url += `?date_filter=${period.filter}`;
        getCarbonRevenueOverTime(url);
      }
    };

    getUrl(period);
  }, [period, startDate, endDate]);

  return (
    <ShaDowBox style={{ width: "100%" }}>
      {data.length ? (
        <div className={classes.box} id="carbon-revenue-over-time">
          <Typography variant="h4">{title}</Typography>
          <UnrealizedBarChart
            chartData={data}
            height={300}
            top={50}
            colors={CARBON_REVENUES_COLORS}
          />
        </div>
      ) : (
        <NoDataCard title={title} />
      )}
    </ShaDowBox>
  );
};
